import { DataBean } from "../DataBean";

export class Apply extends DataBean {



    public async applyBankingStatementToBankingConciliation(idBankingConciliation:any,idBankingStatement:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_applyBankingStatementToBankingConciliation_Number_Number", [idBankingConciliation,idBankingStatement]);
    }

    
}